import { ProductEdited, ProductType } from '../models';
import { SmartSequenceModelEdited } from './smart-sequence-model-edited';

export class SmartSequenceEdited implements ProductEdited<SmartSequenceModelEdited> {
  slug: string; // productSlug (during edition, there is no perimeter)
  name: string;
  data: SmartSequenceModelEdited;
  updatedAt?: Date;
  documents?: string[]; //used on send
  visible?: boolean;
  active?: boolean;
  publishedAt?: Date;
  productType?: ProductType;
  shareInProgress?: boolean;
  folderProduct?: {
    slug: string;
  };
  hasConfigDraft?: boolean;

  constructor(edited?: SmartSequenceEdited) {
    this.slug = edited?.slug;
    this.name = edited?.name;
    this.data = edited?.data ? new SmartSequenceModelEdited(edited.data) : new SmartSequenceModelEdited();
    this.updatedAt = edited?.updatedAt ? new Date(edited.updatedAt) : null;
    this.publishedAt = edited?.publishedAt ? new Date(edited.publishedAt) : null;
    this.productType = ProductType.SMART_SEQUENCE;
    this.shareInProgress = edited?.shareInProgress ?? false;
    this.folderProduct = edited?.folderProduct;
    this.hasConfigDraft = edited?.hasConfigDraft ?? false;
  }
}
